<h3>
  {{ data.details.title.split(" ")[0] }}
  <span> {{ data.details.title.split(" ")[1] }}</span>
</h3>

<!-- <p-carousel
  dir="ltr"
  [value]="groupedServices"
  [numVisible]="1"
  [numScroll]="1"
  [showIndicators]="true"
>
  <ng-template let-items pTemplate="item">
    <div class="row px-3">
      <div
        class="col-6 col-sm-4 col-md-3 p-1"
        *ngFor="let item of items; let i = index"
      >
        <div
          class="text-center"
          [ngClass]="{ pointer: item.link }"
          (click)="openLink(item.link)"
        >
          <img [src]="item.image" [alt]="item.name" class="w-100" />

        </div>
      </div>
    </div>
  </ng-template>
</p-carousel> -->

<!-- <div *ngIf="data" class="d-flex flex-wrap">
  <img
    *ngFor="let item of data.details.services; let index = index"
    class="w-25"
    [src]="item.image"
    [alt]="item.name"
    style="cursor: pointer; object-fit: contain"
    (click)="imageClick(index)"
  />
</div> -->

<p-galleria
  [value]="data.details.services"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [responsiveOptions]="responsiveOptions"
  [containerStyle]="{}"
  [numVisible]="7"
  [circular]="true"
  [fullScreen]="true"
  [showItemNavigators]="true"
  [showThumbnails]="false"
>
  <ng-template pTemplate="item" let-item>
    <img
      [src]="item.image"
      style="width: 100%; height: 100vh; object-fit: contain"
    />
  </ng-template>
</p-galleria>

<!-- <div class="image-grid">
  <img
    *ngFor="let item of data.details.services; let index = index"
    [src]="item.image"
    [alt]="item.name"
    class=""
    (click)="imageClick(index)"
  />
</div> -->

<div *ngIf="data?.details?.services" class="row">
  <div class="column" *ngFor="let column of columns">
    <img
      *ngFor="let item of column; let index = index"
      [src]="item.image"
      [alt]="item.name"
      class="gallery-img"
      (click)="imageClick(item.index)"
    />
  </div>
</div>
